import{types}from'mobx-state-tree';export const CategoryModel=types.model('CategoryModel',{id:types.identifier,name:types.string,sortId:types.integer});